import { useVersionIndicatorQuery as useBaseQuery } from 'generated/apiTypes';



export function useVersionIndicatorQuery() {
  return useBaseQuery();
}
